<template>
  <div>
    <div class="search-input">
        <Input search enter-button="搜索" v-model="searchKey" placeholder="请输入知识点关键词" @on-search="searchKnowledge"/>
    </div>
    <!-- <xbzTableCom :columns='columns'
        :httpData="{
            url: '/v1/platform/class/getStudentPageList',
            listKeyArr: ['result', 'list'],
            totalKeyArr: ['result', 'total'],
        }"></xbzTableCom> -->
    <Table
        :loading="loadingTable"
        border
        :columns="columns"
        :data="knowledgePointList"
        sortable="custom"
        ref="table"
    >
        <template slot-scope="{ row }" slot="difficulty">
            <Tag color="green" v-if="row.difficulty===1">容易</Tag>
            <Tag color="blue" v-else-if="row.difficulty===2">较易</Tag>
            <Tag color="gold" v-else-if="row.difficulty===3">一般</Tag>
            <Tag color="magenta" v-else-if="row.difficulty===4">较难</Tag>
            <Tag color="red" v-else>困难</Tag>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button size="small" type="primary" @click="showInfoModal(row)" style="margin-right:5px;">开始练习</Button>
          <Button size="small"  type="success" @click="viewKnowledgeResolution(row)" >知识点解析</Button>
        </template>
    </Table>
    
    <!-- 知识点解析 -->
    <Modal width="650" v-model="resolveModal" class="know-resolution" :z-index="9999">
        <div class="title">{{currResolution.title}}</div>
        <div class='rate'>
            <div>试题引用：{{currResolution.totalCount}}次</div>
            <div>
                <span v-if="currResolution.difficulty === 1">简单</span>
                <span v-else-if="currResolution.difficulty === 2">一般</span>
                <span v-else-if="currResolution.difficulty === 3">难</span>
                <span v-else-if="currResolution.difficulty === 4">偏难</span>
                <span v-else>较难</span>
                <Rate disabled v-model="currResolution.difficulty" />
            </div>
        </div>
        <div class="resolve">
            <div class="text" v-if="currResolution.txtSolution">
                <div style='color:#FF9D00'>文字解析：</div>
                <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="currResolution.txtSolution" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />   
            </div>
            <div class="video" v-if="currResolution.videoSolution">
                <div>视频解析：</div>
                <video :src="currResolution.videoSolution" controls></video>
            </div>
        </div>
    </Modal>
    <!-- 当前知识点信息弹框 -->
    <Modal v-model="infoModal" class='infoModal' width="460"  >
        <div class="title">题库练习</div>
        <div class="con">
            <div class="top">
                <div>知识点名称：<span>{{currQuestionInfo.knowledgePointName}}</span></div>
                <div v-if="currQuestionInfo.totalCount>0">总题目数：<span>{{currQuestionInfo.totalCount}}道</span></div>
                <div v-if="currQuestionInfo.multipleChoiceCount>0">单选题数量：<span>{{currQuestionInfo.multipleChoiceCount}}道</span></div>
                <div v-if="currQuestionInfo.multipleSelectionCount>0">多选题数量：<span>{{currQuestionInfo.multipleSelectionCount}}道</span></div>
                <div v-if="currQuestionInfo.trueFalseCount>0">判断题数量：<span>{{currQuestionInfo.trueFalseCount}}道</span></div>
                <div v-if="currQuestionInfo.fillsCount>0">填空题数量：<span>{{currQuestionInfo.fillsCount}}道</span></div>
                <!-- <div v-if="currQuestionInfo.essayCount>0">主观题数量：<span>{{currQuestionInfo.essayCount}}道</span></div> -->
                <div v-if="currQuestionInfo.programmingCount>0">编程题数量：<span>{{currQuestionInfo.programmingCount}}道</span></div>
            </div>
            <div class="choose-num">
                <Form ref="formData" :model="formData" :label-width="80" :rules="formDataValidate">
                    <FormItem prop="multipleChoiceCount" label="单选题：" v-if="currQuestionInfo.multipleChoiceCount>0">
                        <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.multipleChoiceCount +'道'">
                            <InputNumber v-model="formData.multipleChoiceCount" type="number" :max="currQuestionInfo.multipleChoiceCount" :min="0" autocomplete="off"/>
                        </Tooltip>
                    </FormItem>
                    <FormItem prop="multipleSelectionCount" label="多选题：" v-if="currQuestionInfo.multipleSelectionCount>0">
                        <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.multipleSelectionCount +'道'">
                            <InputNumber v-model="formData.multipleSelectionCount" type="number" :max="currQuestionInfo.multipleSelectionCount" :min="0" autocomplete="off"/>
                        </Tooltip>
                    </FormItem>
                    <FormItem prop="trueFalseCount" label="判断题：" v-if="currQuestionInfo.trueFalseCount>0">
                        <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.trueFalseCount +'道'">
                            <InputNumber v-model="formData.trueFalseCount" type="number" :max="currQuestionInfo.trueFalseCount" :min="0" autocomplete="off"/>
                        </Tooltip>
                    </FormItem>
                    <FormItem prop="fillsCount" label="填空题：" v-if="currQuestionInfo.fillsCount>0">
                        <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.fillsCount +'道'">
                            <InputNumber v-model="formData.fillsCount" type="number" :max="currQuestionInfo.fillsCount" :min="0" autocomplete="off"/>
                        </Tooltip>
                    </FormItem>
                    <!-- <FormItem prop="essayCount" label="主观题：" v-if="currQuestionInfo.essayCount>0">
                        <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.essayCount +'道'">
                            <InputNumber v-model="formData.essayCount" type="number" :max="currQuestionInfo.essayCount" :min="0" autocomplete="off"/>
                        </Tooltip>
                    </FormItem> -->
                    <FormItem prop="programmingCount" label="编程题：" v-if="currQuestionInfo.programmingCount>0">
                        <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.programmingCount +'道'">
                            <InputNumber v-model="formData.programmingCount" type="number" :max="currQuestionInfo.programmingCount" :min="0" autocomplete="off"/>
                        </Tooltip>
                    </FormItem>
                </Form>
                <div class="tip">提示：输入自己想要完成的类型数目进行答题</div>
            </div>
            <Button size="large" @click="toPractiseKnowledge">开始练习</Button>
        </div>
        
    </Modal>
  </div>
</template>
<script>
import mavonEditor from './components/mavonEditor.vue'
import countTime from './components/countTime.vue'
import questionSingle from './components/questionSingle.vue'
import questionMultiple from './components/questionMultiple.vue'
import questionJugle from './components/questionJugle.vue'
import questionSubject from './components/questionSubject.vue'
import questionFillBlank from './components/questionFillBlank.vue'
import util from '@/libs/util'
export default {
    components: { countTime, questionSingle, questionMultiple, questionJugle, questionSubject, questionFillBlank, mavonEditor },
    props:{
        knowledgePointList:{
            type: Array,
            default:null
        },
        loadingTable:{
            type: Boolean,
            default:false
        }
    },
  data() {
    return {
        infoModal: false,
        currQuestionInfo: {},
        formData: {
            multipleChoiceCount: 0,
            multipleSelectionCount: 0,
            trueFalseCount: 0,
            fillsCount: 0,
            essayCount: 0,
            programmingCount: 0,
        },
        formDataValidate: {
            multipleChoiceCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
            multipleSelectionCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
            trueFalseCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
            fillsCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
            essayCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
            programmingCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
        },
        currKnowledgeId: '',
        currKnowledgeName: '',
        currResolution: '',
        currInfo: {},// 当前知识点信息

        loading:false,
        searchKey:'',
        modalShow: false,
        showResultModal: false,
        showResolutionBox:false,
        resolveModal: false,
        timeSpend:'2分3秒',
        columns:[
            {
                title: '知识点名称',
                width: 220,
                key: "knowledgePointName",
                align: "center",
                tooltip: true
            },
            {
                title: '关联试题数量',
                width: 160,
                key: "testCount",
                align: "center",
                render: (h, params) => {
                    let text = params.row.questionInfo.totalCount
                    return h("div", text);
                }
            },
            {
                title: '难度系数',
                width: 160,
                key: "difficulty",
                slot: "difficulty",
                align: "center",
                tooltip: true
            },
            {
                title: '练习次数',
                width: 160,
                key: "practiceCount",
                align: "center",
                tooltip: true
            },
            {
                title: '正确率',
                minWidth: 220,
                key: "accuracy",
                align: "center",
                // render: (h, params) => {
                //     let text = params.row.accuracy*100 + '%';
                //     return h("div", text);
                // }
            },
            { 
                title: "操作",
                key: "action",
                width: 260,
                align: "center",
                fixed: "right",
                slot: "action"
            }
        ],
        submitLoading: false,
        singleAnwer: "",
        multipleAnswer: [],
        jugleAnswer: "",
        subjectAnswer: '',
        fillAnswer:'',
        currItemInfo: {},
        childTimeInfo: {},
        userInfo: {}
    }
  },
  mounted(){
      this.userInfo = util.localGet('userInfo')
      this.length = this.knowledgePointList.length
  },
  methods: {
    searchKnowledge(){
        this.$emit('childSearch',this.searchKey)
    },
    showInfoModal(item){
        this.infoModal = true
        this.currQuestionInfo = item.questionInfo
        this.currKnowledgeId = item.knowledgePointId
        this.currKnowledgeName = item.knowledgePointName
        this.currQuestionInfo.knowledgePointName = item.knowledgePointName
    },
    toPractiseKnowledge(){
        this.$refs.formData.validate(async valid => {
            if(valid){
                let params = {
                    userId: this.userInfo.id,
                    userName: this.userInfo.username,
                    batchType: 0,
                    batchTypeItemId: this.currKnowledgeId,
                    multipleChoiceCount: this.formData.multipleChoiceCount,
                    multipleSelectionCount: this.formData.multipleSelectionCount,
                    trueFalseCount: this.formData.trueFalseCount,
                    fillsCount: this.formData.fillsCount,
                    essayCount: this.formData.essayCount,
                    programmingCount: this.formData.programmingCount,
                }
                if(!params.multipleChoiceCount && !params.multipleSelectionCount && !params.trueFalseCount && !params.fillsCount && !params.programmingCount ){
                    // 选项均为0
                    this.$Message.info('请输入您要练习的类型数量')
                    return false
                }
                util.md5Encryption(params)
                const res = await this.postTKRequest('/v1/getPracticeBatchInfo',params,true)
                if(res.success){
                    util.localSet('questionIds',{ knowledgeName: this.currKnowledgeName, batchId: res.result.batchId,questionIds: JSON.stringify(res.result.questionIds) } )
                    this.childTimeInfo = {}
                    this.$router.push({
                        name: 'knowledgeStrongPractise',
                    })
                }
            }
        })
    },
    // 查看知识点解析
    async viewKnowledgeResolution(item){
        let params = {
            userId: this.userInfo.id,
            id: item.knowledgePointId
        }
        const res = await this.postTKRequest('/v1/getKnowledgePointDetail', util.md5Encryption(params) ,true)
        if(res.success){
            if(res.result.txtSolution){
                res.result.txtSolution = decodeURIComponent(res.result.txtSolution)
            }
            this.currResolution = res.result
            this.currResolution.totalCount = item.questionInfo.totalCount
            this.resolveModal = true
        }
    }
  },
  watch: {},
  computed: {}
}
</script>
<style scoped lang="less">
.infoModal{
    /deep/ .ivu-modal-content{
        background-color: transparent;
    }
    /deep/ .ivu-modal-body{
        padding: 0;
    }
    /deep/ .ivu-modal-footer{
        display: none;
    }
    .title{
        position: relative;
        z-index: 1;
        width: 100%;
        height: 130px;
        line-height: 130px;
        text-align: center;
        color: #fff;
        font-size: 30px;
        background: url('../../assets/modalTop.png') no-repeat;
        background-size: 100% 100%;
    }
    .con{
        margin-top: -10px;
        width: 100%;
        padding: 30px 20px 20px;
        background-color: #fff;
        border-radius: 0 0 10px 10px ;
        .top{
            display: inline-flex;
            flex-wrap: wrap;
            padding-bottom: 20px;
            margin-bottom: 20px;
            border-bottom: 1px dashed #ccc;
            div{
                width: 40%;
                height: 30px;
                line-height: 30px;
                span{
                    color: #ffa200;
                }
            }
            div:first-child{
                width: 100%;
            }
            div:nth-child(2){
                width: 100%;
            }
        }
        .choose-num{
            .ivu-form{
                display: inline-flex;
                flex-wrap: wrap;
                .ivu-form-item:nth-child(2n){
                    margin-left: 30px;
                }
            }
            .tip{
                background: #F0F0F0;
                color: #999;
                padding: 5px 10px;
                border-radius: 4px;
                width: 72%;
                margin-bottom: 40px;
            }
        }
        /deep/ .ivu-btn{
            width: 100%;
            background: #ffa200;
            color: #fff;
        }
    }
}
.ivu-badge{
    margin: 0 20px 20px 0;
}
.demo-badge{
    padding: 0 20px;
    height: 34px;
    line-height: 34px;
    background: #fff;
    border-radius: 18px;
    display: inline-block;
}
.search-input{
    width: 300px;
    margin-bottom: 30px;
}
.know-resolution{
    padding: 20px;
    /deep/ .ivu-modal-footer{
        display: none;
    }
    /deep/ .ivu-modal-body{
        padding: 16px 40px 30px 40px
    }
    .title{
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
        border-bottom: 1px solid #ccc;
    }
    .rate{
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        text-align: right;
        margin: 15px 0 20px;
        font-size: 16px;
        /deep/ .ivu-rate {
            font-size: 24px;
            margin-left: 10px;
        }
    }
    .times{
        font-size: 16px;
    }
    .resolve{
        .text{
            margin-bottom: 50px;
            div:first-child{
                font-size: 16px;
                color: #ffa200;
            }
            /deep/ img{
                max-width: 100%;
            }
        }
        .video{
            div:first-child{
                font-size: 16px;
                color: #ffa200;
            }
            /deep/ video{
                max-width: 100%;
            }
        }
        
    }
}
.knowModal{
    .title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 70px;
    }
    .item-num{
        span{
            padding: 5px 10px;
            margin-right: 10px;
            border-radius: 4px;
            border: 1px solid #ccc;
            cursor: pointer;
        }
    }
    
    .item-footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        /deep/ .ivu-btn{
            padding: 0 40px;
        }
    }
    /deep/ .ivu-modal-footer{
        display: none;
    }
}
.item-detail{
    margin:20px 0;
    overflow: hidden;
    padding: 0 20px;
    
}
.resultModal{
    .re-title{
        width: 100%;
        text-align: center;
        font-weight: 700;
        font-size: 20px;
    }
    .re-counts{
        width: 400px;
        display: flex;
        justify-content: space-between;
        height: 70px;
        align-items: center;
    }
    .re-num{
        span{
            padding: 5px 10px;
            margin-right: 10px;
            border-radius: 4px;
            border: 1px solid #ccc;
            cursor: pointer;
        }
    }
    .right-rate{
        position: absolute;
        top: 0;
        right: 0;
        padding: 20px;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #eee;
        // color: #fff;
        border-radius:0 6px 0 6px;
    }
    .re-spend{
        margin: 20px 0;
    }
    .right-key{
        background-color: #eee;
        padding: 20px;
        display: inline-flex;
        width: 100%;
        justify-content: space-between;
        border-radius: 6px;
        span:last-child{
            cursor: pointer;
        }
    }
    .re-resolution{
        padding: 10px;
        /deep/ img{
            max-width: 100%;
        }
        /deep/ video{
            max-width: 100%;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/views/practise/knowledgeStrong.vue